import supabase from "artifact/supabase";
import connected from "standard/connected";
import define from "standard/define";
import on from "standard/on";
import paint from "standard/paint";
import repaint from "standard/repaint";
import trait from "standard/trait";
import willPaint from "standard/willPaint";
import style from "./style";

@define("m-avaliation")
class Avaliation extends HTMLElement {
  #data;
  #corrected;

  get [trait.corrected]() {
    return (this.#corrected ??= []);
  }

  get [trait.data]() {
    return (this.#data ??= []);
  }

  constructor() {
    super();
    this.attachShadow({ mode: "open" });
  }

  @connected
  @paint
  async [trait.template]() {
    return `
      <table class="${style.avaliation}">
        <thead class="${style.avaliation__thead}">
          <tr class="${style.avaliation__tr}">
            <th class="${style.avaliation__th}">Estudante</th>
            <th class="${style.avaliation__th}">Arquivo</th>
            <th class="${style.avaliation__th}">Status</th>
            <th class="${style.avaliation__th}">Atividade</th>
          </tr>
        </thead>
        <tbody class="${style.avaliation__tbody}">
          ${this[trait.data]
            .map(
              (x) =>
                `
              <tr class="${style.avaliation__tr}">
                <td class="${style.avaliation__td}">${x.user.name}</td>
                <td class="${style.avaliation__td}">
                  <a href="//hzinyrqqkeqizojcotoj.supabase.co/storage/v1/object/public/activities/${this.dataset.activity}/${x.user.id}" target="_blank">Download</a>
                </td>
                ${
                  this[trait.corrected].find(
                    (y) =>
                      y?.activity_criterion?.activity_id === x.activity_id &&
                      y.student_id === x.user.id,
                  )
                    ? `
                      <td class="${style.avaliation__td}">
                        <span>Corrigido</span>
                      </td>
                      <td></td>
                    `
                    : `
                      <td class="${style.avaliation__td}">
                        <strong>Aguardando</strong>
                      </td>
                      <td class="${style.avaliation__td}">
                        <button data-id="${x.user.id}">Avaliar</button>
                      </td>
                    `
                }
              </tr>
            `,
            )
            .join("")}
        </tbody>
      </table>
    `;
  }

  @willPaint
  async [trait.fetch]() {
    const { data } = await supabase
      .from("activity_completed")
      .select("*, user(*)")
      .eq("activity_id", this.dataset.activity);

    const { data: corrected } = await supabase
      .from("activity_corrected")
      .select("*, activity_criterion(activity_id)")
      .eq("activity_criterion.activity_id", this.dataset.activity);

    this.#corrected = corrected;
    this.#data = data;
    return this;
  }

  @on.click("button")
  [trait.open](event) {
    window.dispatchEvent(
      new CustomEvent("check:open", { detail: event.target.dataset.id }),
    );
    return this;
  }
}

export default Avaliation;
